export var KubernetesAccessMode;
(function (KubernetesAccessMode) {
    KubernetesAccessMode["ReadWriteOnce"] = "READ_WRITE_ONCE";
    KubernetesAccessMode["ReadWriteMany"] = "READ_WRITE_MANY";
    KubernetesAccessMode["ReadOnlyMany"] = "READ_ONLY_MANY";
    KubernetesAccessMode["ReadWriteOncePod"] = "READ_WRITE_ONCE_POD";
    KubernetesAccessMode["KubernetesAccessModeUnspecified"] = "KUBERNETES_ACCESS_MODE_UNSPECIFIED";
})(KubernetesAccessMode || (KubernetesAccessMode = {}));
